export const localText = {
  emailLabel: 'Email',
  emailPlaceholder: 'user@bmw.de',
  hubLabel: 'Hub',
  hubPlaceholder: 'Select hub',
  businessObjectLabel: 'Business object (BO)',
  businessObjectPlaceholder: 'Select BO',
  ticketUrlLabel: 'Ticket URL',
  ticketUrlPlaceholder: 'https://...',
  unableToAddGovernorTitle: 'Unable to add governor',
  missingFieldsError: 'Enter an email, hub, and business object.',
  missingTicketError: 'Enter a ticket URL for production changes.',
} as const
